/**
 * Created by neo on 01.01.17.
 */

import Config from '../Config';
import Backend from './Backend';

const Buffer = require('buffer/').Buffer;

/**
 * Special class that does calls the backend by using the app credentials (client_credentials)
 */
class AppBackend {

  authData = null;

  authorize() {
    if (this.authData === null) {
      // console.tron.log('trying to get authData');
      const backend = new Backend();
      const authKey = Buffer(`${Config.backend.clientId}:${Config.backend.clientSecret}`).toString('base64');
      const headers = {
        Authorization: `Basic ${authKey}`,
        Accept: 'application/json'
      };

      const payload = {
        grant_type: 'client_credentials',
        client_id: Config.backend.clientId,
        client_secret: Config.backend.clientSecret,
        scope: Config.backend.scopes,
      };
      // console.tron.log(headers);
      // console.tron.log(payload);
      return backend.postForm('/oauth/token', payload, headers).then(res => {
        // console.tron.log(res);
        if (res.ok) {
            this.authData = res.data;
            return this.authData;
        }
        throw Error('Invalid authentication');
      });
    }

    return Promise.resolve(this.authData);
  }

  post(path, data, headers = {}) {
    return this.authorize().then((authData) => {
      // console.tron.log(authData);
      return new Backend(authData).post(path, data, headers);
    });
  }

  put(path, data, headers = {}) {
    return this.authorize().then((authData) => {
      // console.tron.log(authData);
      return new Backend(authData).put(path, data, headers);
    });
  }

  delete(path, params?: any, headers?: any = {}) {
    return this.authorize().then((authData) => {
      // console.tron.log(authData);
      return new Backend(authData).delete(path, params, headers);
    });
  }

  get(path, data, headers) {
    return this.authorize().then((authData) => {
      return new Backend(authData).get(path, data, headers);
    });
  }

  upload(path: string, data: any, progressHandler: (progressEvent: any) => void) {
    return this.authorize().then((authData) => {
      return new Backend(authData).upload(path, data, progressHandler);
    });
  }
}

const instance = new AppBackend();
export default instance;



// WEBPACK FOOTER //
// ./src/App/Services/AppBackend.js